import Header from "./Header";
import Dacdiem from "./Dacdiem";
import Quytrinh from "./Quytrinh";
import Congthuc from "./Congthuc";
import Loiich from "./Loiich";
import Vitri from "./Vitri";
import Faq from "./Faq";
import Danhgia from "./Danhgia";
import Contact from "./Contact";

export default function Homerutbaogia() {
  return (
    <div>
     <Header />
          <Quytrinh />
          <Loiich />
          <Vitri />
          <Contact />
    </div>
  );
}
